import api from 'lib/api'
import type { Filter } from 'lib/store'

interface DataVacancy {
  count: number
  currentPage: number
  data: any[]
  totalPages: number
}

export const getVacancies = async (
  filter: Filter,
  slug: string
): Promise<DataVacancy> => {
  try {
    const params = { take: 12, slug, ...filter }
    const response = await api<{ data: DataVacancy }>('/home/vacancy', {
      params
    })

    if (response.data?.data) {
      return response.data.data
    }
  } catch (err) {
    console.log(err)
  }

  return { count: 0, currentPage: 0, data: [], totalPages: 0 }
}

export const getVacancyApplied = async (
  vacancyId: number,
  preApplied: boolean
): Promise<'pre-applied' | 'applied' | ''> => {
  if (preApplied) {
    return 'pre-applied'
  }

  try {
    const response = await api<{ applied: boolean }>(
      '/selective-process/vacancy/' + vacancyId,
      {},
      'applicants'
    )

    if (response.data.applied) {
      return 'applied'
    }
  } catch (err) {
    console.error(err)
  }

  return ''
}

export const getCitiesInVacancies = async (slug: string): Promise<string[]> => {
  try {
    const params = { slug }
    const response = await api<{ name: string }[]>('/home/cities', { params })

    const cities = response.data.map(item => item.name)

    return ['Todos', ...cities]
  } catch (err) {
    console.log(err)
  }

  return []
}
